<div class="card h-100 w-100 border-gray-500 radius-8 p-6  card-parent " [class]="comFromWhat == 'projects' ? item.isActive ? 'border-start border-2 border-info' : 'border-start border-2 border-success' : ''">
    <!-- Card title -->
    <ng-container>
      <div class="project-header d-flex justify-content-between">
        <div class="text-capitalize d-flex align-items-center pointer mb-2 w-75" [routerLink]="comFromWhat == 'projects' ?[item.id , 'tasks']:null">
            <span [innerHTML]="icons.iconBook"></span>
            <span class="fs-14 margin-bottom-minus text-black w-75" *ngIf="item.name">{{item.name || "..." }}</span>
            <span class="fs-14 margin-bottom-minus text-black" *ngIf="item.title">{{item.title || "..." }}</span>
        </div>
        <div class="d-flex " *ngIf="item.companyLogo"  >
          <img  *ngFor="let logo of item.companyLogo ; let i = index" style="width: 25px; height: 25px;object-fit: cover;" [src]="path+'/'+logo" alt="" placement="top" ngbTooltip="{{ item.companyId[i] == 3 ? 'آفاق  لمنح الشهادات والتفتيش' :  item.companyId[i] == 4 ? 'بيان للخدمات البيئية' : item.companyId[i] == 7 ? 'الثقة للاستشارات الادارية' : item.companyId[i] == 25 ? 'دكتور جرين' : ''}}">

        </div>
        <!-- <div class="project-left">
          <div class="dropdown w-auto text-center"[ngStyle]="{'left': lang=='ar'? '0px':'87%'}" >
            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> <i class="bi bi-three-dots-vertical"></i> </button>
            <ul   class="dropdown-menu" [ngClass]="{'left-toogle-body': lang=='ar'}">

                <li class="p-0 m-2 dropdown-item" (click)="open(item , false , 'view')" *ngIf="canView">
                  {{'GENERAL.VIEW' | translate}}
                </li>
              <li class="p-0 m-2 dropdown-item" (click)="open(item , true , 'edit')" *ngIf="canEdit">
                {{'GENERAL.EDIT' | translate}}
              </li>
            <li class="p-0 m-2 dropdown-item" (click)="deleteItem(item.id)" *ngIf="canDelete">
              {{'GENERAL.DELETE' | translate}}
              </li>


              </ul>
        </div>
        </div> -->

      </div>
    </ng-container>
    <!-- -------------- task approval acions --------------- -->
    <ng-container *ngIf="comFromWhat == 'tasks'">
        <div class="dropdown" *ngIf="item.isApproved == false" [ngStyle]="{'left': lang=='ar'? '0px':'87%'}">
            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> <i class="bi bi-three-dots-vertical"></i> </button>
            <ul class="dropdown-menu" [ngClass]="{'left-toogle-body': lang=='ar'}">
                <li><a  class="dropdown-item" (click)="AddTaskApproval(item.id , true)">{{"REQUESTS.Accept"| translate}}</a></li>
                <li><a  class="dropdown-item" (click)="AddTaskApproval(item.id , false)">{{"REQUESTS.Reject"| translate}}</a></li>
            </ul>
        </div>
        <!-- <div class="text-capitalize d-flex align-items-center pointer fs-16">
            <span [innerHTML]="icons.iconList"></span>
            <ng-container>
                <span class="mx-1 text-black">{{(item.title | slice: 0: 75) || "..." }}</span>
            </ng-container>
        </div> -->
    </ng-container>


    <!-- ------------------- Employees View ==> with ==>  Department view  -------------- -->
    
    <div class="col-12 d-flex flex-wrap fs-6 mb-1 mt-1">
        <div class="text-main d-flex align-items-center justify-content-start col-sm-6">
            <span class="mr-1" [innerHTML]="icons.iconMan" *ngIf="!item.taskEmployees"  ></span>
            <span class="mr-1" [innerHTML]="icons.iconMan" *ngIf="item.taskEmployees"  placement="top" ngbTooltip= "{{allEmployeesName }}" (mouseenter)="onMouseEnter(item.taskEmployees)" (mouseleave)="onMouseLeave()"></span>
            <!-- --------- Created By View ------- -->
            <span class="fs-12 margin-bottom-minus text-main BarlowMedium" *ngIf="comFromWhat == 'projects'">{{item.createdBy  || "..."}}</span>
            <!-- ------- Employees View ------ -->
            <span class="d-flex overflow-x-hidden" *ngIf="comFromWhat == 'tasks'" >
                <span placement="top" ngbTooltip=" {{emp.name}}" class="badge badge-pill mx-1 border-gray-800 text-capitalize rounded-circle p-1 px-2 bg-task{{item.taskStage_Id}} text-light" *ngFor="let emp of item?.taskEmployees">
                    {{emp.name.charAt(0)}}
                </span>
            </span>
        </div>
        <!-- ------- Department View ------ -->
        <div class="text-main d-flex align-items-center justify-content-end col-sm-6" *ngIf="!hideDepartment">
            <span class="bg-stock px-8 pb-1 border-radius-8 text-start d-flex align-items-center">
                <span [innerHTML]="icons.iconDepartment"></span>
                <small class="fs-10 fw-bold margin-bottom-minus text-main BarlowMedium" *ngIf="item.departmentName">{{item.departmentName || "..." }}</small>
            </span>
        </div>
    </div>

    <!-- ------------------- Start Date  && End Date  -------------- -->
    <div class="col-12 d-flex flex-wrap fs-6">
        <div class="text-main d-flex align-items-center justify-content-start col-sm-6">
            <div class="d-flex align-items-center justify-content-center" *ngIf="item.startDate" >
                <span [innerHTML]="icons.iconCalendar"></span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.startDate" placement="top" ngbTooltip = "Start Date ">  {{ comFromWhat === 'tasks' ? (item.startDate | date: 'yyyy/MM/dd') : item.startDate || '...' }} </span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.startDate && isInViewTaskWithoutProject && lang == 'ar'" placement="top" ngbTooltip = "Start Time ">  {{(comFromWhat == 'tasks')? DateToArabic(item.startDate) : item.endDate || "..." }} </span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.startDate && isInViewTaskWithoutProject && lang == 'en'" placement="top" ngbTooltip = "Start Time ">  {{(comFromWhat == 'tasks')? (item.startDate | date: 'shortTime') : (item.endDate || "..." )}} </span>
            </div>
        </div>
        <div class="text-main d-flex align-items-center justify-content-end col-sm-6" >
            <div class="d-flex align-items-center justify-content-center"  *ngIf="item.endDate"  >
                <span [innerHTML]="icons.iconCalendar"></span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.endDate" placement="top" ngbTooltip = "End Date ">  {{(comFromWhat == 'tasks')?(item.endDate | date : "yyyy/MM/dd"):(item.endDate) || "..." }} </span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.endDate && isInViewTaskWithoutProject && lang == 'ar'" placement="top" ngbTooltip = "End Time ">  {{(comFromWhat == 'tasks')? DateToArabic(item.endDate) : item.endDate || "..." }} </span>
            <span class="fs-6 margin-bottom-minus text-main BarlowMedium" *ngIf="item.endDate && isInViewTaskWithoutProject && lang == 'en'" placement="top" ngbTooltip = "End Time ">  {{(comFromWhat == 'tasks')? (item.endDate | date: 'shortTime') : (item.endDate || "...") }} </span>
            </div>
        </div>
    </div>

    <!-- ------------------- card bottom view  -------------- -->
    <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="d-flex justify-content-between align-items-center">
            <span class="p-2 d-flex fw-bold">
                <span class="position-badge" [ngSwitch]="+item.priority_Id">
                    <span *ngSwitchCase="1">
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                    </span>
                    <span *ngSwitchCase="2">
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                    </span>
                    <span *ngSwitchCase="3">
                        <i class="bi bi-star-fill text-warning fs-6"></i>
                    </span>
                </span>
                <ng-container *ngIf="comFromWhat == 'projects'">
                    <span class="d-flex" *ngIf="!item.priority_Id" [routerLink]="[item.id , 'tasks']">
                        <!-- <b class="pointer count-w bg-gray-500 rounded-circle text-light d-flex align-items-center justify-content-center" *ngIf="comFromWhat != 'projects'">0</b> -->
                        <!-- <b class="pointer count-w bg-blue rounded-circle text-light d-flex align-items-center justify-content-center" *ngIf="comFromWhat != 'projects'">0</b> -->
                        <b class="pointer count-w bg-warning rounded-circle text-light d-flex align-items-center justify-content-center" *ngIf="comFromWhat == 'projects'">{{item.tasksCountArePending || 0}}</b>
                        <b class="pointer count-w bg-success rounded-circle text-light d-flex align-items-center justify-content-center" *ngIf="comFromWhat == 'projects'">{{item.tasksCountAreApproved || 0}}</b>
                        <!-- <b class="pointer count-w bg-danger rounded-circle text-light d-flex align-items-center justify-content-center" *ngIf="comFromWhat != 'projects'">0</b> -->
                    </span>
                </ng-container>
            </span>


        </div>
        <!-- <div class="d-flex justify-content-between align-items-center">
            <img style="width: 25px; height: 25px;object-fit: cover;" src="../../../../assets/images/logo-afaq.png" alt="">
        </div> -->



        <div class="d-flex">
          <i class="bx bxs-show  text-success fs-5 me-1 pointer" (click)="open(item , false , 'view')" *ngIf="canView"></i>
          <i  class="bx bxs-edit-alt text-warning fs-5 me-1 pointer" (click)="open(item , true , 'edit')" *ngIf="canEdit"></i>
          <i class="bx bxs-trash text-danger fs-5 me-1 pointer" (click)="deleteItem(item.id)" *ngIf="canDelete"></i>
        </div>
    </div>
</div>

